const LOG_PREFIX = "[OCM][PageSense] "
let pageSense = async (utils) => {
  return new Promise((resolve, reject) => {
    let pageType = 'ROS';
    let subPaths = window.location.pathname.replace("/", "").split("/") || [];
    let customPaths = ["diagwnismoi", "market-news", "market-news", "epikoinonia", "oroi-xrisis"];
    let subCategories = ["news-super-trends", "h-moda-ton-stars", "shopping-moda", "street-style", "gamos", "elle-fashion-young-talents-awards", "makigiaz", "peripioihsh", "aisthitikes-paremvaseis", "mallia", "aromata", "diaita-diatrofi", "fitness-sport", "elle-zen", "igeia-euexia", "psixologia", "spitia", "idees-diakosmisis", "design-news", "sintages", "taxidi", "lifestyle", "texni", "celebrity-news", "page"];
    // Keep only String values in subPaths (removes null and empty)
    subPaths = subPaths.filter(String);
    // The actual page sense goes here
    if (subPaths.length === 0) {
      pageType = "Home";
    } else if (subPaths.length === 1) {
      if (customPaths.indexOf(subPaths[0]) >= 0) {
        pageType = "Custom-1";
      } else {
        pageType = "Category";
      }
    } else if (subPaths.length === 2) {
      if (subCategories.indexOf(subPaths[1]) >= 0) {
        pageType = "Category";
      } else {
        pageType = "Article";
      }
    } else if (subPaths.length >= 3) {
      if (subCategories.indexOf(subPaths[2]) >= 0) {
        pageType = "Category";
      } else {
        pageType = "Article";
      }
    }

    const blocked_url = [
      '/living/tonia-sotiropoulou-elle-diethnes-festival-kinimatografou-venetias/',
      'moda/nona-se-apognosi-ti-back2school-doro-na-pareis-sto-pio-dyskolo-isos-paidi-tou-planiti/',
      'moda/axesouar-individual-brand/',
      'moda/three-industry-trailblazers-talk-balancing-career-with-personal-missions/',
      'living/ergeniki-zoi-glyka-kai-vasana',
      'living/sygkatoikisi-2-skylia',
      'living/lifestyle/family-issues-katharo-spiti-dysonv15',
      'elle.gr/omorfia/la-prairie-skincare-routina-omorfia/',
      'omorfia/la-prairie-skincare-routina-omorfia/',
      'elle.gr/moda/genevieve-majari/',
      'omorfia/clean-beauty/',
      'moda/to-self-expression-mesa-apo-tin-techni/',
      'moda/yamamay-stylish-oikologiki-pnoi/',
      'living/o-dikos-mas-kafes-borei-na-einai-filikos-pros-to-perivallon/',
      'moda/how-to-style/',
      'moda/to-look-tis-imeras/',
      'moda/to-look-tis-imeras-t-shirt/',
      'moda/to-look-tis-evdomadas-to-athlitiko-mou-outfit-echei-sustainable-diathesi/',
      'elle.gr/yperoxo-kormi/afta-einai-ta-6-mystika-gia-apolyti-evexia/',
      'elle.gr/yperoxo-kormi/afto/',
      'moda/afto-to-lefko-poukamiso-einai-all-time-class-chic-3-tropoi-na-to-foreseis-tora/',
      '/moda/black-dress-nivea/',
      '/moda/black-blazer/',
      '/omorfia/to-mono-filtro-pou-tha-chreiasteis-fetos-to-kalokairi/',
      '/omorfia/antigiransi-ligo-prin-kai-ligo-meta-ta-prota-anta-ta-proionta-pou-mas-esosan/',
      '/omorfia/editors-approved-ta-proionta-pou-chreiazesai-afto-to-kalokairi/',
      '/moda/mystiko-black-white-look',
      '/moda/summer-collectibles-by-prigipo-to-elliniko-brand-kosmimaton-gemizei-me-panemorfa-dora-to-kalokairi-mas/',
      '/omorfia/antigiransi-ligo-prin-kai-ligo-meta-ta-prota-anta-ta-proionta-pou-mas-esosan/',
    ];
    
    for (let i = 0; i < blocked_url.length; i++) {
      if (utils.window.location.href.includes(blocked_url[i])) {
        pageType = 'block'
        break
      }
    }

    resolve(pageType)
  });
};
module.exports = pageSense;